import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';

export const Container = styled.div`
  flex: 1;
  grid-area: forecast;
  height: 80px;
  margin: 0 15px;
`;

export const Heading = styled.h2`
  font-weight: normal;
  text-align: left;
  margin: 0 0 0 0px;
`;
